// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__xUXxh","pulse":"Skeleton_pulse__pVLfK"};